module.exports = __webpack_public_path__ + "vue/img/icon-b-03.0439cc9a.png";